export class HotspotIdentifiers {
  public static DIFF_STATS = {
    changed: "most_changed_files",
    touched: "most_touched_files",
  };
}
